import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useContent } from '../hooks/useContent';
import { ADMIN_PATH, adminApi } from '../lib/api';

export function LoginPage() {
  const [email, setEmail] = useState(() => localStorage.getItem('admin_remember_email') || '');
  const [password, setPassword] = useState('');
  const [accessCode, setAccessCode] = useState('');
  const [remember, setRemember] = useState(() => !!localStorage.getItem('admin_remember_email'));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const c = useContent();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const resp = await fetch(adminApi('/api/auth/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, accessCode }),
      });
      const data = await resp.json();
      if (!resp.ok) {
        setError(data.error || '登录失败');
        return;
      }
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_email', data.email);
      if (remember) {
        localStorage.setItem('admin_remember_email', email.trim().toLowerCase());
      } else {
        localStorage.removeItem('admin_remember_email');
      }
      navigate(ADMIN_PATH);
    } catch {
      setError('网络错误');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-gray-100 flex items-center justify-center">
      <div className="w-full max-w-md">
        <Link to="/" className="text-2xl font-bold gradient-text block text-center mb-8">CXAI-FreeRouter</Link>
        <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-8">
          <h1 className="text-xl font-bold mb-6 text-center">{c.login_title || '管理后台登录'}</h1>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="text-sm text-gray-400 block mb-1">邮箱</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-sm focus:border-cyan-500 outline-none"
                required
              />
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">密码</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-sm focus:border-cyan-500 outline-none"
                required
              />
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">安全登录码</label>
              <input
                type="password"
                value={accessCode}
                onChange={e => setAccessCode(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-2 bg-gray-900 border border-gray-800 rounded-lg text-sm focus:border-cyan-500 outline-none"
              />
            </div>
            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-sm text-gray-400 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={e => setRemember(e.target.checked)}
                  className="accent-cyan-500"
                />
                记住账号
              </label>
            </div>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 bg-cyan-500/20 text-cyan-400 rounded-lg font-medium hover:bg-cyan-500/30 transition disabled:opacity-50"
            >
              {loading ? '登录中...' : '登录'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}